export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14968.1204bc85.jpg";